import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { colors } from '@styleseat/brand';
import withStore from '../../../withStore';
import NotificationBanner from '../NotificationBanner';
import MESSAGE_ICON from '../../../../../images/icons/icon-message-square-text.svg';
import { PRO_CLIENT_LIST } from '../../../../route-names';

const AddClientNotification = ({ notification, linkTo }) => {
  const handleButtonClick = () => {
    linkTo(PRO_CLIENT_LIST, { source: 'notification' });
  };

  const clickTracking = {
    name: 'pro_notification_add_client_button_clicked',
    params: {
      providerId: notification.provider_id,
    },
  };

  const buttonProps = {
    text: 'Add my clients',
    onClick: handleButtonClick,
    clickTracking,
    appearance: 'text-light',
    size: 'small',
  };

  return (
    <NotificationBanner
      notification={notification}
      icon={MESSAGE_ICON}
      iconSize={36}
      highlightedText="Add your clients to your client list. Then invite them to book with you on StyleSeat."
      subText="New clients don’t like an empty calendar, add your regulars and invite them to book with you."
      highlightBorderColor={colors.spark}
      buttonProps={buttonProps}
    />
  );
};

AddClientNotification.propTypes = {
  notification: PropTypes.object.isRequired,
  linkTo: PropTypes.func,
};

AddClientNotification.defaultProps = {
  linkTo: () => { },
};

const mapDispatchToProps = dispatch => ({
  linkTo: (route, params, notify = true) => {
    dispatch.route.go({
      route,
      params,
      notify,
    });
  },
});

export default withStore(connect(null, mapDispatchToProps)(AddClientNotification));
